import type { ClassificationStoreValue } from "~/types/mdsa.types";

export function getValueStrings(values: ClassificationStoreValue[]) {
  return values.map((value) => value.valueString);
}

export function getValueBooleans(values: ClassificationStoreValue[]) {
  return values.map((value) => value.valueBoolean);
}
